import { IGroup } from "@grassrootly/api/entities";
import { provider } from "@grassrootly/api/providers";

export type UpdateGroupPayload = {
  id: number;
  paylod: FormData;
};

export const UpdateGroup = async (params: UpdateGroupPayload): Promise<IGroup> =>
  provider.Request("/group/{id}", params);
